// @ts-expect-error Untyped import
import { ReportingTracker } from '../../lib/usageTracker';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import InlineFeedback from 'ai-components-ui-library/components/feedback/InlineFeedback';
import ReportCardV2 from 'reporting-enablement/components/ReportCard/ReportCardV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEMPLATE_CARD_HEIGHT = '400px';
const AiSearchResultItem = ({
  template,
  messageId,
  explanation,
  templateKey,
  onResultClick,
  onResultFeedbackClick
}) => {
  return /*#__PURE__*/_jsxs(GridItem, {
    size: {
      sm: 12,
      lg: 6
    },
    marginBlock: "0",
    marginBlockEnd: "800",
    marginInline: "0",
    children: [/*#__PURE__*/_jsx(ReportCardV2, {
      blockSize: TEMPLATE_CARD_HEIGHT,
      report: template,
      header: /*#__PURE__*/_jsx(Link, {
        truncate: true,
        truncateStringProps: {
          useFlex: false
        },
        onClick: () => {
          onResultClick(template, templateKey);
        },
        children: template === null || template === void 0 ? void 0 : template.get('name')
      })
    }, template === null || template === void 0 ? void 0 : template.get('templateKey')), /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "400",
      marginBlockEnd: "200",
      children: explanation
    }), /*#__PURE__*/_jsx(InlineFeedback, {
      messageId: messageId,
      usageTracker: ReportingTracker,
      onPositiveFeedback: args => {
        onResultFeedbackClick(args, templateKey);
      },
      onNegativeFeedback: args => onResultFeedbackClick(args, templateKey)
    })]
  });
};
export default AiSearchResultItem;